import { makeJsonRequest } from "../../utils/JsonRequests";
import { HttpMethods } from "../../utils/HttpMethods";
import { Logger } from "../../utils/Logger";
import { getUserAdapter } from "../../gtm/GtmUtils";
import { singleton } from "tsyringe";
import { ReadEventDto } from "./ReadEventDto";
import { getCookie } from "typescript-cookie";
import { GeoLocationCookie } from "../../shared/geoLocation/GeoLocationCookie";

/**
 * Indicate the URL used to send ReadJs events to the API.
 * Initialized at compile time via WebPack.
 */
declare const ReadJsUrl: string;

@singleton()
export class ReadJsApiClient {
  public async sendReadJsEvent(articleId: string | undefined): Promise<void> {
    const user = getUserAdapter();
    if (!articleId) {
      Logger.log("ReadJsApi: Article ID is missing.");
      return;
    }
    if (!user) {
      Logger.error("ReadJsApi: User not available!");
      return;
    }

    const body = {
      articleId: articleId,
    } as ReadEventDto;
    if (user.rcId) {
      body.rcId = user.rcId;
      body.rcPlus = user.rc_plus_id;
    } else if (user.rc_visitor_id) {
      body.rcVisitor = user.rc_visitor_id;
    } else {
      Logger.error("Neither RCID nor RCVisitorId are available!");
      return;
    }
    body.fsa = this.getFsa();
    if (body.fsa) {
      if (body.fsa === "hors canada") {
        Logger.log("Invalid FSA:", body.fsa);
        body.fsa = undefined;
      } else if (body.fsa.length > 3) {
        Logger.warn(`Could not log FSA. Length is greater than 3. Value: ${body.fsa}`);
        body.fsa = undefined;
      }
      // FSA should be valid.
    }
    Logger.verbose("Sending ReadJs Event", body);
    let response: Response | undefined;
    try {
      response = await makeJsonRequest(ReadJsUrl, HttpMethods.POST, "omit", body);
    } catch (e) {
      Logger.error(`Failed to send ReadJs event. Error:${e}`);
    }
    if (!!response && !response.ok) {
      await Logger.requestError("Failed to send ReadJs event.", response);
    }
  }

  private getFsa(): string | undefined {
    const json = getCookie("RC_CFA_GEO_INFO");
    if (!json) {
      return undefined;
    }
    const geoLocation = JSON.parse(json) as GeoLocationCookie;
    return geoLocation?.user?.fsa;
  }
}
